export default "__VITE_ASSET__2bbed1dd__"